import React from "react";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Page from "components/Page";

const Perfil = (datos, handleCambiarContrasenia) => {
  let datosUsuario = datos["datos"];
  return (
    <Page title="Perfil" breadcrumbs={[{ name: "Perfil", active: true }]}>
      {/*console.log("datos recibidos ", datos["datos"])*/}
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>Datos del Usuario</CardHeader>
            <CardBody>
              <Row>
                <Col md={6} sm={6} xs={6} className="mb-3">
                  <h4>
                    Nombres:
                    <p>
                      <strong>
                        {datosUsuario === undefined ? "" : datosUsuario.nombres}{" "}
                      </strong>
                    </p>
                  </h4>
                </Col>
                <Col md={6} sm={6} xs={6} className="mb-3">
                  <h4>
                    Apellidos:{" "}
                    <p>
                      <strong>
                        {datosUsuario === undefined
                          ? ""
                          : datosUsuario.apellidos}{" "}
                      </strong>
                    </p>
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col md={6} sm={6} xs={6} className="mb-3">
                  <h4>
                    Identificación:{" "}
                    <p>
                      <strong>
                        {datosUsuario === undefined ? "" : datosUsuario.cedula}{" "}
                      </strong>
                    </p>
                  </h4>
                </Col>
                <Col md={6} sm={6} xs={6} className="mb-3">
                  <h4>
                    Correo Electrónico:{" "}
                    <p>
                      <strong>
                        {datosUsuario === undefined ? "" : datosUsuario.correo}{" "}
                      </strong>
                    </p>
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col md={6} sm={6} xs={6} className="mb-3">
                  <h4>
                    Sucursal:{" "}
                    <p>
                      <strong>
                        {datosUsuario === undefined
                          ? ""
                          : datosUsuario.sucursal}{" "}
                      </strong>
                    </p>
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col md={12} sm={12} xs={12} className="mb-3">
                  <Link to={`/cambiar-contrasenia`}>
                    <Button className="btn btn-primary button-align-rigth">
                      <i className="fa fa-pencil-square-o" aria-hidden="true" />{" "}
                      CAMBIAR CONTRASEÑA
                    </Button>
                  </Link>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Page>
  );
};

export default Perfil;
